export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Sirve si recién estoy arrancando como docente?',
    a: 'Sí. El Tomo 1 empieza desde los fundamentos absolutos y cada tomo tiene una lógica didáctica progresiva. Pensado tanto para docentes que inician como para los que quieren profesionalizar su material con contexto argentino actualizado al 2026.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. PDFs de alta calidad optimizados para pantalla o impresión.',
  },
  {
    q: '¿El Upsell Premium es necesario?',
    a: 'Si solo querés mejorar tus clases con material técnico listo, el MEGAPACK base es suficiente. Si además querés la profundización en tecnología forense avanzada y el sistema completo para convertirte en referente docente, el Upsell Premium es la mejor inversión de tu carrera.',
  },
  {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día podés tener una actividad del Bono 2 aplicada en el aula. La mayoría de los docentes implementa cambios visibles en la primera semana.',
  },
  {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a nuestro contacto dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.',
  },
  {
    q: '¿Aplica para cualquier nivel educativo?',
    a: 'Sí. Secundario técnico, terciario policial, terciario de ciencias forenses o formación universitaria con orientación en Criminalística, Criminología o Derecho Penal. También aplica para docentes de Ciencias Naturales, Física o Química que quieren incorporar la Criminalística como contenido de aplicación científica real.',
  },
  {
    q: '¿Necesito conocimientos avanzados de Criminalística para usarlo?',
    a: 'No. Cada tomo empieza desde lo conceptual con ejemplos claros y avanza con rigor técnico graduado. Si sos docente de ciencias sin especialización en criminalística, este material fue pensado especialmente para vos.',
  },
]
